<div class="container-fluid">
    <!-- Page Header -->
    <div class="row pt-4 pl-4" style="font-size: 22px !important; font-weight: 400; color: #424242;">
      <h5>
        <i class="fa fa-circle" style="color:#800000"></i> &nbsp; Contract Letter
      </h5>
    </div>
  
    <div id="mainContent" class="container">
      <div class="modal-body">
        <div class="row">
          <!-- Branch Selection -->
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label">
                Branch <span class="text-danger">*</span>
              </label>
              <div class="col-sm-6">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                    <!-- Select All Option -->
                    <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">
                      Select All
                    </mat-option>
                    <!-- Dynamic Branch List -->
                    <mat-option #item (click)="onBranchSelected()" *ngFor="let branch of branchList" [value]="branch">
                      {{ branch.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label">
                Reporting Partner <span class="text-danger">*</span>
              </label>
              <div class="col-sm-6">
                <select
                  class="form-control form-control-xs mt-1"
                  [(ngModel)]="selectedReportingPartner"
                  (change)="onPartnerSelected()"
                >
                  <option value="">Select Partner</option>
                  <option *ngFor="let partner of reportingPartnerList" [ngValue]="partner">
                    {{ partner.firstName }} {{ partner.middleName }} {{ partner.lastName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label">
                Employee Name <span class="text-danger">*</span>
              </label>
              <div class="col-sm-6">
                <select
                  class="form-control form-control-xs mt-1"
                  [(ngModel)]="selectedEmployeeName"
                >
                  <option value="">Select Employee</option>
                  <option *ngFor="let emp of employeeList" [ngValue]="emp">
                    {{ emp.firstName }} {{ emp.middleName }} {{ emp.lastName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>  
        <!-- Export Letter Button -->
        <div class="row mt-3">
          <div class="col-sm-2">
            <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="ExportLetter()">
              Export Letter
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  